import { Card, Col, Row } from "antd";
import type { Constat } from "../../../types/constats";
import spacing from "../../../components/ui/spacingConfig";
import StatusBadges from "../../../components/tables/StatusBadges";
import AttachmentPreview from "../../../components/ui/AttachmentPreview";

type Props = {
  constatData: Constat | undefined;
  className?: string;
};

const CardDescriptionConstat: React.FC<Props> = ({ constatData, className }) => {
  return (
    <Card title="Description" bordered={false} className={className}>
      <Row>
        <Col span={spacing.xxxs}>
          <p className="text-light-grey">Statut</p>
        </Col>
        <Col span={spacing.s}>
          <p>
            {constatData?.statut ? (
              <StatusBadges value={constatData?.statut} type="events" />
            ) : (
              "Not found"
            )}
          </p>
        </Col>
      </Row>
      <Row>
        <Col span={spacing.xxxs}>
          <p className="text-light-grey">Titre</p>
        </Col>
        <Col span={spacing.s}>
          <p>{constatData?.name}</p>
        </Col>
      </Row>
      <Row>
        <Col span={spacing.xxxs}>
          <p className="text-light-grey">Description</p>
        </Col>
        <Col span={spacing.s}>
          <p className="text-small-size">{constatData?.description}</p>
        </Col>
      </Row>
      <Row>
        <Col span={spacing.xxxs}>
          <p className="text-light-grey">Auteur</p>
        </Col>
        <Col span={spacing.s}>
          <p className="text-light-blue">{constatData?.creator?.fullname}</p>
        </Col>
      </Row>
      <Row>
        <Col span={spacing.xxxs}>
          <p className="text-light-grey">PiÃ¨ces jointes</p>
        </Col>
        <Col span={spacing.s}>
          <div className="attachments-container">
            {constatData?.attachedFiles.map((file) => (
              <AttachmentPreview key={file.id} fileUrl={file.file} />
            ))}
          </div>
        </Col>
      </Row>
    </Card>
  );
};

export default CardDescriptionConstat;
